<template>
	<div>
		<navbar :list="menuList"></navbar>
		<el-row>
			<el-col :span="4">
				<sidebar></sidebar>
			</el-col>
			<el-col :span="20" style="padding: 20px">
				<router-view></router-view>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import {
		Navbar,
		Sidebar
	} from './components'
	export default {
		components: {
			Navbar,
			Sidebar
		},
		data() {
			return {
				menuList: []
			};
		},
		created() {
			this.userInfo = this.$store.state.userInfo;
			if (!this.userInfo) {
				window.location.href = "/admin.html#/login";
			}

			this.getMenuList();
		},
		methods: {
			getMenuList() {
				this.$H.get("user/userRuleList").then(res => {
					this.menuList = res.result;

					if (!this.$store.state.sideBar) {
						this.$store.state.sideBar = res.result[0].children;
						localStorage.setItem("sideBar", res.result[0].children);
					}
					
				})
			}
		}
	}
</script>

<style>
	.el-header {
		padding: 0px;
	}
</style>
